import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export const FASES = ["Lendo arquivo", "Carregando base atual", "Processando linhas", "Gravando no banco", "Concluído"];

export function useImportJob(onDone) {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const cbRef = useRef(onDone);
  cbRef.current = onDone;

  const stop = () => { if (timer.current) { clearInterval(timer.current); timer.current = null; } };

  const poll = useCallback((jobId) => {
    stop();
    timer.current = setInterval(async () => {
      try {
        const { data } = await api.get(`/estoque/import/jobs/${jobId}`);
        setJob(data);
        if (data.status === "concluido") { stop(); cbRef.current?.(data.resultado); setTimeout(() => setJob(null), 4000); }
        if (data.status === "erro") { stop(); toast.error(`Falha na importação: ${data.erro}`); setTimeout(() => setJob(null), 8000); }
      } catch { stop(); toast.error("Erro ao consultar progresso da importação"); }
    }, 1000);
  }, []);

  const start = useCallback(async (url, file) => {
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post(url, fd);
      setJob({ job_id: data.job_id, status: "processando", fase: "Lendo arquivo", atual: 0, total: 0 });
      poll(data.job_id);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao enviar arquivo");
    }
  }, [poll]);

  const reset = useCallback(() => { stop(); setJob(null); }, []);
  useEffect(() => stop, []);

  return { job, start, reset, running: job?.status === "processando" };
}
